import React from "react";
import { Card, CardActionArea, Box, Typography, Chip } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const AddPaymentMethodCard = ({ onClick }) => {
  return (
    <Card
      role="button"
      aria-label="Add payment method"
      sx={{
        borderRadius: 4,
        boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
        transition: "all 0.25s ease",
        overflow: "hidden",
        inlineSize: 300,
        blockSize: 180,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        backgroundColor: "#ffffff",
        position: "relative",
        "&:hover": {
          boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
          transform: "translateY(-2px)",
        },
      }}
    >
      <CardActionArea
        onClick={onClick}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          blockSize: "100%",
          color: "text.secondary",
          p: 2,
        }}
      >
        <Box
          sx={{ position: "absolute", insetBlockStart: 12, insetInlineEnd: 12 }}
        >
          <Chip label="Add New" color="primary" size="small" />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "12px",
            backgroundColor: "#e3f2fd",
            inlineSize: 72,
            blockSize: 72,
            mb: 1,
            transition: "transform 200ms ease, box-shadow 200ms ease",
            color: "#1976d2",
            "&:hover": {
              transform: "scale(1.06)",
            },
          }}
        >
          <AddCircleOutlineIcon sx={{ fontSize: 36, color: "#1976d2" }} />
        </Box>

        {/* Only the icon and New chip are shown per design request */}
      </CardActionArea>
    </Card>
  );
};

export default AddPaymentMethodCard;
